import React from 'react';

const Telefonia = () => {
  const categorias = [
    { 
      name: "Fundas premium", 
      description: "Protege tu móvil con estilo. Disponemos de fundas de silicona, transparentes, con patrón, antigolpes, con soporte y de piel ecológica. Encuentra la que mejor se adapte a ti.",
      image: "https://images.unsplash.com/photo-1586953208448-b95a79798f07?w=400"
    },
    { 
      name: "Cargadores rápidos", 
      description: "Carga tus dispositivos al máximo rendimiento con nuestros cargadores de última generación. Tecnología de carga rápida para que nunca te quedes sin batería.",
      image: "https://images.unsplash.com/photo-1586953208448-b95a79798f07?w=400"
    },
    { 
      name: "Auriculares Hi-Fi", 
      description: "Sumérgete en un sonido de alta fidelidad. Auriculares inalámbricos y con cable para disfrutar de tu música con la mejor calidad de audio.",
      image: "https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=400"
    },
    { 
      name: "Aros de luz 4K", 
      description: "Ilumina tus videollamadas y directos como un profesional. Aros de luz ajustables con diferentes temperaturas de color y intensidad.",
      image: "/images/aros de luz.jpg"
    },
    { 
      name: "Ksix Collection", 
      description: "Descubre la gama de accesorios Ksix: smartwatches, altavoces, auriculares y más. Tecnología accesible con diseño moderno y funcional.",
      image: "https://images.unsplash.com/photo-1586953208448-b95a79798f07?w=400"
    },
    { 
      name: "Cool Tech", 
      description: "Lo último en gadgets y tecnología cool. Productos innovadores que harán tu día a día más fácil y divertido.",
      image: "https://images.unsplash.com/photo-1586953208448-b95a79798f07?w=400"
    },
    { 
      name: "Gear Gaming", 
      description: "Equípate como un pro. Ratones, teclados, cascos y alfombrillas gaming para llevar tu experiencia de juego al siguiente nivel.",
      image: "https://images.unsplash.com/photo-1586953208448-b95a79798f07?w=400"
    }
  ];

  return (
    <div>
      <div className="container">
        <div className="section-header">
          <h2>Accesorios y tecnología</h2>
          <div className="underline"></div>
          <p style={{ marginTop: '1rem', color: '#6B7280' }}>
            Todo lo que necesitas para tu dispositivo, en un solo lugar.
          </p>
        </div>

        <div className="card-container">
          {categorias.map((categoria, index) => (
            <div className="card" key={index}>
              <img src={categoria.image} alt={categoria.name} className="card-image" />
              <div className="card-content">
                <h3>{categoria.name}</h3>
                <p>{categoria.description}</p>
                <button 
                  className="btn-outline" 
                  style={{ marginTop: '1rem', width: '100%' }}
                  onClick={() => {
                    const telefono = "34640975055";
                    const mensaje = `Hola, me interesa ver los productos de ${categoria.name}. ¿Podéis informarme?`;
                    window.open(`https://wa.me/${telefono}?text=${encodeURIComponent(mensaje)}`, '_blank');
                  }}
                >
                  Consultar disponibilidad
                </button>
              </div>
            </div>
          ))}
        </div>

        <div style={{ marginTop: '4rem', padding: '2rem', background: '#F9FAFB', borderRadius: '24px', textAlign: 'center', border: '1px solid #E5E7EB' }}>
          <h3 style={{ fontFamily: "'Playfair Display', serif", fontSize: '1.4rem', color: '#1A1A1A' }}>
            🛍️ ¿No encuentras lo que buscas?
          </h3>
          <p style={{ marginTop: '0.5rem', color: '#6B7280' }}>
            Tenemos muchas más opciones en tienda. ¡Ven a visitarnos o consúltanos por WhatsApp!
          </p>
          <button 
            className="btn" 
            style={{ marginTop: '1rem' }}
            onClick={() => {
              const telefono = "34640975055";
              const mensaje = "Hola, me gustaría recibir información sobre vuestros productos y accesorios.";
              window.open(`https://wa.me/${telefono}?text=${encodeURIComponent(mensaje)}`, '_blank');
            }}
          >
            Consultar por WhatsApp
          </button>
        </div>
      </div>
    </div>
  );
};

export default Telefonia;